export const NO_PAIRING_CHOICE = "none";

export const JOURNAL_SETTINGS = [
	{
		attribute: "basis",
		label: "Revenue recognised",
		monthPrompt:
			"Months before this one keep the basis they were built on. Revenue that straddles the switch — invoiced on one side of it and paid on the other — is counted twice or not at all, so the month chosen is the line a reviewer adjusts across.",
		choices: [
			{ value: "salesDetail", label: "When invoiced (accrual) — from the Sales detail" },
			{ value: "appliedPayments", label: "When payment is applied (cash) — from the Applied and Unapplied Payments" }
		]
	},
	{
		attribute: "account",
		label: "Revenue account",
		noneConsequence: "Every sale is credited to one revenue account.",
		choices: [
			{ value: "item", label: "Each item names its own revenue account" },
			{ value: NO_PAIRING_CHOICE, label: "One revenue account for every sale" }
		]
	},
	{
		attribute: "site",
		label: "Each Jane site is recorded as",
		noneConsequence: "Lines stop carrying the site, so every report by site stops working from this journal on.",
		choices: [
			{ value: "qboLocation", label: "A QuickBooks location — no class on any line" },
			{ value: "qboClass", label: "A QuickBooks class — no location on any line" },
			{ value: NO_PAIRING_CHOICE, label: "Not recorded" }
		]
	},
	{
		attribute: "receivable",
		label: "Receivable",
		noneConsequence: "New receivable lines stop. Whatever the receivable account already holds stays there until someone corrects it.",
		choices: [
			{ value: "accountsReceivable", label: "Book what Jane's Accounts Receivable report says is owed" },
			{ value: NO_PAIRING_CHOICE, label: "No receivable" }
		]
	}
];

export const SITE_PAIRING_WORDS = {
	qboLocation: { one: "location", many: "locations" },
	qboClass: { one: "class", many: "classes" }
};

export const SITE_COLUMNS = {
	location: { heading: "Location", nameField: "locationName" },
	class: { heading: "Class", nameField: "className" }
};

export const EXPECTED_REPORTS = [
	{ key: "billingSummary", label: "Billing Summary", supplies: "Total revenue invoiced and applied, tax, refunds, and revenue by location and by category" },
	{ key: "salesDetail", label: "Sales detail", supplies: "Every sold line — split by staff, item or location" },
	{ key: "appliedPayments", label: "Applied and unapplied payments", supplies: "Every payment applied to an invoice this month — split by staff, item or location" },
	{ key: "accountsReceivable", label: "Accounts Receivable", supplies: "What patients, insurers and other payers owe" },
	{ key: "payments", label: "Jane Payments & Transactions", supplies: "Merchant fees and card takings" }
];
